import axios, { AxiosResponse } from "axios";
import { OrderHistory } from "../@types/order-history";

const BASE_URL = "https://sodastreamapi.azurewebsites.net/order-history";
class OrderHistoryService {

  async getLatestOrderHistory(waybill: string): Promise<{ data: OrderHistory[] | null; error: string | null }> {
    try {
      const response: AxiosResponse<OrderHistory[]> = await axios.get(`${BASE_URL}/orders/latest/${waybill}`);
      
      if (response.status >= 200 && response.status < 300) {
        const latestOrderHistory: OrderHistory[] = response.data; 

        return { data: latestOrderHistory, error: null };
      } else {
        const error = `Error fetching latest order history for reference number: ${waybill}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching latest order history:", error.message);
      return { data: null, error: error.message };
    }
  }
  
  async getAllOrderHistories(): Promise<{ data: OrderHistory[] | null; error: string | null }> {
    try {
      const response: AxiosResponse<OrderHistory[]> = await axios.get(`${BASE_URL}`);
      if (response.status >= 200 && response.status < 300) {
        const orderHistories: OrderHistory[] = response.data;

        return { data: orderHistories, error: null };
      } else {
        const error = "Error fetching order histories";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching order histories:", error);
      return { data: null, error };
    }
  }


  async getOrderHistoryById(historyId: number): Promise<{ data: OrderHistory | null; error: string | null }> {
    try {
      const response: AxiosResponse<OrderHistory> = await axios.get(`${BASE_URL}/id/${historyId}`);
      if (response.status >= 200 && response.status < 300) {
        const orderHistory: OrderHistory = response.data;

        return { data: orderHistory, error: null };
      } else {
        const error = "Error fetching order history by ID";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching order history by ID:", error);
      return { data: null, error };
    }
  }

  async getOrderHistoryByUserId(waybill: string): Promise<{ data: OrderHistory[] | null; error: string | null }> {
    try {
      const response: AxiosResponse<OrderHistory[]> = await axios.get(`${BASE_URL}/orders/latest/${waybill}`);
      if (response.status >= 200 && response.status < 300) {
        const orderHistories: OrderHistory[] = response.data;

        return { data: orderHistories, error: null };
      } else {
        const error = "Error fetching order histories by user ID";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching order histories by user ID:", error);
      return { data: null, error };
    }
  }

  async createOrderHistory(waybill: string, status: string): Promise<{ data: { message?: string } | null; error: string | null }> {
    try {
      const orderHistoryData = {
       
        status,
        waybill,
        createdAt: new Date().toISOString(), 
      };
  
      const response: AxiosResponse<{ message?: string }> = await axios.post(`${BASE_URL}`, orderHistoryData);
      
      if (response.status >= 200 && response.status < 300) {
        const message = response.data.message || 'No message provided';

        return { data: { message }, error: null };
      } else {
        const error = `Error creating order history - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error creating order history:", error.message);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }
  
  
  async updateOrderHistory(historyId: number, updateData: any): Promise<{ data: OrderHistory | null; error: string | null }> {
    try {
      const response: AxiosResponse<OrderHistory> = await axios.put(`${BASE_URL}/orderHistories/${historyId}`, updateData);
      if (response.status >= 200 && response.status < 300) {
        const updatedOrderHistory: OrderHistory = response.data;

        return { data: updatedOrderHistory, error: null };
      } else {
        const error = `Error updating order history - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error updating order history:", error.message);
      return { data: null, error: error.message };
    }
  }


  async deleteOrderHistory(historyId: number): Promise<{ data: any | null; error: string | null }> {
    try {
      const response: AxiosResponse<any> = await axios.delete(`${BASE_URL}/orderHistories/${historyId}`);
      if (response.status >= 200 && response.status < 300) {
       
        return { data: response.data, error: null };
      } else {
        const error = `Error deleting order history - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error deleting order history:", error.message);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }
}


const orderHistoryServiceInstance = new OrderHistoryService();
export default orderHistoryServiceInstance;
